import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, Platform, ToastController, LoadingController } from 'ionic-angular';
// import { JugadoresPage } from "../jugadores/jugadores";
// import { EntrenadoresPage } from "../entrenadores/entrenadores";
import { AuxiliaresPage } from "../auxiliares/auxiliares";
import { API, APIOnLine } from "../../services/api/api.services";
import { BasePage } from '../../models/basePage';
import { pouchdb } from "../../services/pouchdb/pouchdb.service";
import { MenuDerechoComponent } from "../../components/menu-derecho/menu-derecho";
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { Popover } from 'ionic-angular/components/popover/popover';
import { Http } from "@angular/http";
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-equipo',
  templateUrl: 'equipo.html'
})
export class EquipoPage extends BasePage {

  jugadoresRoot: any;
  entrenadoresRoot: any;
  auxiliaresRoot: any;

  public esEquipoLocal: boolean = false;
  public desig:Proxy.PrDesignaciones;

  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    public http: Http,
    public toastCtrl: ToastController,
    public DBService: pouchdb.DBService,
    public navParams: NavParams,
    public Params: API.ParametrosAlineacion,
    public menuCtrl: MenuController,
    public SessionService: API.SessionService,
    private popOverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public Persistentes: APIOnLine.Persistentes
  ) {
    super(navCtrl, platform, http, toastCtrl, DBService, loadingCtrl);

    // this.jugadoresRoot = JugadoresPage;
    // this.entrenadoresRoot = EntrenadoresPage;
    this.auxiliaresRoot = AuxiliaresPage;
  }

  ionViewDidEnter() {

    this.desig = this.Persistentes.GetDesignacion();
    this.esEquipoLocal = this.desig.EquipoLocal(this.Persistentes.GetIdEquipo());

  }

  // #region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(MenuDerechoComponent, {
      primeraParte: true
    });

    popover.present({
      ev: event
    });
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/equipo/equipo.ts